import { useState, useEffect, useCallback } from "react";
import generalSettings from "@apis/generalSettings";
import { toast } from "react-toastify";

export const useGeneralSettings = () => {
  const [settings, setSettings] = useState<{
    timeZone: string;
    timeFormat: string;
    currency: string;
    currencySymbol: string;
    currencyPosition: string;
    isDecimal: boolean;
    decimalPlaces: string;
    topTitle: string;
    middleTitle: string;
    bottomTitle: string;
  }>({
    timeZone: "",
    timeFormat: "",
    currency: "",
    currencySymbol: "",
    currencyPosition: "",
    isDecimal: false,
    decimalPlaces: "2",
    topTitle: "",
    middleTitle: "",
    bottomTitle: "",
  });

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [existing, setExisting] = useState<any>(null);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    try {
      const res = await generalSettings.getByKey({
        state: "generals",
        id: "general-settings",
        showErr: false,
      });
      if (res) {
        setExisting(res);
        setSettings({
          timeZone: res?.infos?.timeZone || "",
          timeFormat: res?.infos?.timeFormat || "",
          currency: res?.infos?.currency || res?.infos?.currencySymbol || "",
          currencySymbol: res?.infos?.currencySymbolCustom || "",
          currencyPosition: res?.infos?.currencyPosition || "",
          isDecimal: res?.infos?.isDecimal || false,
          decimalPlaces: res?.infos?.decimalPlaces || "2",
          topTitle: res?.infos?.topTitle || "",
          middleTitle: res?.infos?.middleTitle || "",
          bottomTitle: res?.infos?.bottomTitle || "",
        });
      }
    } catch (err) {
      console.error(err);
      setError("Failed to fetch general settings");
      toast.error("Failed to fetch general settings");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return { settings, setSettings, existing, loading, error, fetchSettings };
};
